export default __webpack_public_path__ + "static/media/promote-link.9b1abf84.svg";